// extracted by mini-css-extract-plugin
export var dropdownButton = "_49-0";
export var fullWidthDropdownButton = "_49-1";
export var icon = "_49-3";
export var iconPlaceholder = "_49-2";
export var menuItemRow = "_49-9";
export var separator = "_49-e";
export var shortcutContainer = "_49-7";
export var shortcutContainerFilled = "_49-8";
export var shortcutIconLg = "_49-6";
export var shortcutIconMd = "_49-5";
export var shortcutIconSm = "_49-4";
export var submenuChevron = "_49-d";
export var submenuDropdown = "_49-a";
export var submenuTriggerRow = "_49-b";
export var submenuTriggerRowOpen = "_49-c";